import { useVisit } from '../VisitContext';
import { VisitBucketItemWrapper } from '../shared/VisitBucketItemWrapper';
import { FormRegistryProvider } from '~/shared/forms/FormRegistryContext';
import { resolveOasisTasksOptions } from '@generated';
import { convertToServerValues } from './values';

import { VisitTaskFooter } from '../shared/VisitTaskFooter';
import { VisitOasisTask } from './VisitOasisTask';
import { ExternalReferenceValueCopier } from '../shared/ExternalReferenceValueCopier';
import { VisitBucketItemBlocker } from '../shared/VisitBucketItemBlocker';
import { useGetVisitBucketItemOptions, useGetVisitStatusOptions } from '../queries';
import { useQuery } from '@tanstack/react-query';

export function VisitOasisTasks() {
	const { id, selectedVisitBucket, selectedVisitBucketItem, navigateToNextItem } = useVisit();

	const { refetch: refetchVisitStatus } = useQuery(useGetVisitStatusOptions(id));
	const byCategory = Boolean(selectedVisitBucketItem?.category);
	const { refetch: refetchVisitItem } = useQuery(
		useGetVisitBucketItemOptions(
			id,
			selectedVisitBucket.id,
			byCategory ? selectedVisitBucketItem!.category!.name : selectedVisitBucketItem!.oasisTask!.id,
			byCategory ? 'oasis-category' : 'oasis'
		)
	);

	const selectedTasks = selectedVisitBucketItem?.category
		? selectedVisitBucketItem.category.oasisTasks
		: selectedVisitBucketItem?.oasisTask
		? [selectedVisitBucketItem.oasisTask]
		: [];

	if (!selectedVisitBucketItem) {
		throw new Error('No bucket item selected');
	} else if (selectedTasks.length === 0) {
		throw new Error('Selected bucket item does not have any associated tasks');
	}
	return (
		<FormRegistryProvider
			saveMutation={resolveOasisTasksOptions}
			onSaveTransform={values => convertToServerValues(selectedTasks, values)}
			onSuccess={async () => {
				await refetchVisitItem();
				refetchVisitStatus();
				navigateToNextItem?.();
			}}
			showValues
		>
			<VisitBucketItemWrapper footerSlot={<VisitTaskFooter />}>
				<div className="space-y-8">
					{selectedTasks.map(task => (
						<VisitOasisTask key={task.id} oasisTask={task} siblingOasisTasks={selectedTasks.filter(x => x.id !== task.id)} />
					))}
				</div>
			</VisitBucketItemWrapper>
			<VisitBucketItemBlocker />
			<ExternalReferenceValueCopier
				selectedTasks={selectedTasks.map(x => ({
					id: x.id,
					externalReferences: x.oasisDefinition.externalReferences ?? [],
					documentationFormFields: x.oasisDefinition.documentationFormFields ?? []
				}))}
			/>
		</FormRegistryProvider>
	);
}
